export const DASHBOARD_REFRESH = 60 * 3 * 1000; // three minutes in milliseconds
export const HELDUP_HOURS = 48;
